import React, { useState } from 'react';
import { Sidebar, Calendar } from 'components';
import styles from './Home.module.scss';
import clsx from 'clsx';
import { useStateValues } from 'providers';

const Home = () => {
  const { state: { isOpened }, action: { setIsOpened } } = useStateValues();
  const [eventTypeIds, setEventTypeIds] = useState(['in_game', 'twitch_drop', 'race_of_legends', 'sot_shot', 'community']);

  const handleToggleSidebar = e => {
    e.preventDefault();

    setIsOpened(!isOpened);
  };

  return (
    <div className={styles.home}>
      {isOpened ? null : <button className={styles.button} onClick={handleToggleSidebar} />}

      <Sidebar
        eventTypeIds={eventTypeIds}
        setEventTypeIds={setEventTypeIds}
        isOpened={isOpened}
        onClose={() => setIsOpened(false)}
      />

      <div className={clsx(styles.sidebar_space, isOpened && styles['sidebar_space--opened'])} />

      <Calendar isOpened={isOpened} eventTypeIds={eventTypeIds} />
    </div>
  );
};

export default Home;
